import './styles/main.css'
import { router } from './router'
import { on_api_failure } from './lib/api'
import { classify_api_failure, login_redirect_path, should_clear_session, should_redirect_to_login } from './lib/api-failure'
import { clear_auth_cache } from './lib/auth'
import { init_theme } from './lib/theme'
import { ensure_submit_modal_listener } from './lib/submit-modal'
import { install_number_input_wheel_guard } from './lib/number-input-wheel-guard'

install_number_input_wheel_guard()

/**
 * 401 tratado UMA vez, no lugar por onde toda chamada passa.
 *
 * Antes, cada tela decidia sozinha o que fazer com a falha — e a decisão mais
 * comum era `.catch(() => ({ items: [] }))`. Sessão expirada virava "lista
 * vazia": o operador ficava olhando uma tela em branco sem nenhuma indicação de
 * que precisava entrar de novo.
 */
on_api_failure((path, err) => {
  const failure = classify_api_failure(err)
  if (should_clear_session(failure)) clear_auth_cache()

  const atual = window.location.pathname + window.location.search
  if (should_redirect_to_login(path, atual, failure)) {
    // `router.navigate` preserva o destino em `?next=`; o login volta para lá.
    void router.navigate(login_redirect_path(atual), true)
  }
})

async function init(): Promise<void> {
  init_theme()
  const root = document.getElementById('app')
  if (!root) throw new Error('Missing #app')
  router.setup(root)
  ensure_submit_modal_listener()
  await router.navigate(window.location.pathname + window.location.search, false)
}

init().catch((err) => {
  console.error('Init failed:', err)
  const root = document.getElementById('app')
  if (root) {
    root.innerHTML = `
      <main class="grid min-h-screen place-items-center p-6">
        <section class="w-full max-w-md rounded-lg border border-border bg-surface p-6 shadow-card">
          <h1 class="text-xl font-semibold text-ink">Aplicação indisponível</h1>
          <p class="mt-2 text-sm text-muted">O backend pode estar reiniciando. Recarregue em alguns segundos.</p>
          <button class="mt-5 inline-flex h-10 items-center rounded-md bg-brand px-4 text-sm font-semibold text-brand-ink" onclick="window.location.reload()">Tentar novamente</button>
        </section>
      </main>`
  }
})
